"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var to_fixed_1 = __importDefault(require("../utils/to-fixed"));
var Payment = /** @class */ (function () {
    function Payment(id, totalPayment, principlePayment, interestPayment, principleRemaining, interestCumulative) {
        this.id = id;
        this.totalPayment = totalPayment;
        this.principlePayment = principlePayment;
        this.interestPayment = interestPayment;
        this.principleRemaining = principleRemaining;
        this.interestCumulative = interestCumulative;
    }
    Payment.prototype.rebalance = function () {
        if (this.principleRemaining >= 0) {
            return;
        }
        this.totalPayment += this.principleRemaining;
        this.totalPayment = to_fixed_1.default(this.totalPayment, 2);
        this.principlePayment += this.principleRemaining;
        this.principlePayment = to_fixed_1.default(this.principlePayment, 2);
        this.principleRemaining = 0;
    };
    return Payment;
}());
exports.default = Payment;
